<header>
  <div class="container">
    <br />
    <div class="row">
      <div class="col-md-10">
      </div>
      <div class="col-md-2">
        <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700; ">
          <a [routerLink]="['/home-espanol']" style="text-decoration: none; color: inherit; ">
            <div class="container" style="border: 1px solid #257dff; border-radius: 25px; ">
              &nbsp;&nbsp;Español
            </div>
          </a>
        </span>
      </div>
    </div>
  </div>
  <div class="container">
    <br />
    <div class="row">
      <div class="col-md-12">
        <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700">
          GoogleAssistantPrivacyLitigation.com
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(877) 411-4704
        </span>
      </div>
    </div>
  </div>
  <br />
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #257dff ">
    <div class="container">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_lightBlue" [routerLink]="['/home']" style="color: white; font-weight: bold ">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/faq']" style="color: white; font-weight: bold">FAQs</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/notice']" style="color: white; font-weight: bold ">Notice</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/login']" style="color:white; font-weight: bold ">File Your Claim</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/claim-form']" style="color:white; font-weight: bold ">Claim Form</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/court-documents']" style="color:white; font-weight: bold ">Court Documents</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/exclusion-request']" style="color:white; font-weight: bold ">File an Exclusion</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_lightBlue" [routerLink]="['/contact']" style="color:white; font-weight: bold ">Contact Us</a>
          </li>
        </ul>
      </div>
    </div>

  </nav>


</header>
<div class="container" style="border:1px solid #bebaba">

  <br />
  <div class="text-center" style="font-weight:bold">

    This official website is maintained by the Claims Administrator
    <br />
    <br />
    <br />
  </div>
  <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align: center; font-weight: bold">
    <h3>Contact Us</h3>
  </div>
  <div class="row indentContent">
    <div class="col-md-12">
      <br />
      <b><u>Claims Administrator</u></b>:<br /><br />

      Google Assistant Privacy Settlement<br />
      c/o A.B. Data, Ltd.<br />
      P.O. Box 170500<br />
      Milwaukee, WI 53217<br />
      Email: <a href="mailto:info@googleassistantprivacylitigation.com">info@googleassistantprivacylitigation.com</a><br />
      Phone: 1-877-411-4704<br /><br />

      <b><u>Class Counsel:</u></b><br /><br />

      Erin Green Comite<br />
      Scott+Scott Attorneys at Law LLP<br />
      156 South Main Street, P.O. Box 192<br />
      Colchester, CT 06415<br />
      Phone: 860-537-5537<br />
      Email: <a href="mailto:googleprivacysettlement@scott-scott.com">googleprivacysettlement@scott-scott.com</a><br /><br />

      Christian Levis<br />
      Lowey Dannenberg<br />
      44 South Broadway, Suite 1100<br />
      White Plains, NY 10601<br />
      Phone: 914-733-7205<br />
      Email: <a href="mailto:googleprivacysettlement@lowey.com">googleprivacysettlement@lowey.com</a>
    </div>
  </div>
  <div style="width:80%; margin:0 auto; text-align: center; display:block; margin-top: 2%">
    <p>
      Note: These documents are in PDF format. To view the<br />
      documents, you will need <a href="https://get.adobe.com/reader/" target="_blank"
                                  style="color:#0071ce; font-weight:bold">Adobe Acrobat Reader</a>
      on your computer or other internet-enabled device.
    </p>
  </div>
  <div class="row text-center" id="inverse_row">
    <div class="col-md-12">
      <a href="https://get.adobe.com/reader/" target="_blank"><img src="../assets/adobe-pdf-icon.jpg" alt="Adobe Acrobat Reader" width="3%"></a>
    </div>
  </div>
  <br />
</div>
